export const FETCH_API_DATA_FAILURE = 'FETCH_API_DATA_FAILURE';

export function fetchApiDataFailure(payload) {
    return {type: FETCH_API_DATA_FAILURE, payload: payload};
}



// WEBPACK FOOTER //
// ./src/_actions/common.actions.js